module.exports = __webpack_public_path__ + "img/ics_o_clipboard.9c268df9.svg";